<nav class="navbar">
  @if (logoUrl) {
    <div class="navbar__logo">
      <img src="{{ logoUrl }}" alt="Logo" />
    </div>
  }

  <ul class="navbar__panel navbar__panel_rigt">
    @if (isItemVisible() && isStartActionVisible()) {
      <li class="navbar__menu-item">
        <a
          [routerLink]="startPageUrl"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="ph ph-house ph-bold"></i>
          {{ 'Navigation.Start' | translate }}
        </a>
      </li>
      <!-- <li class="navbar__menu-item">
          <a [routerLink]="userActivityUrl" routerLinkActive="active">
            <i class="ph ph-list-dashes ph-bold"></i>
            {{ "Navigation.YourTasks" | translate }}
          </a>
        </li> -->
      @if(showSettings) {
        <li class="navbar__menu-item">
          <a [routerLink]="settingsUrl" routerLinkActive="active">
            <i class="ph ph-gear-six ph-bold"></i>
            {{ 'Navigation.Settings' | translate }}
          </a>
        </li>
      }
    }
    @if (isPauseVisible()) {
      <app-pause-dialog
        openButtonLabel="Navigation.Start"
        openButtonIcon="ph ph-house ph-bold"
      ></app-pause-dialog>
    }
    @if (isAuthenticated()) {
      <tar-dropdown-menu
        [options]="userDropdownOptions()"
        [title]="userName()"
        titleIcon="ph ph-user ph-bold"
      >
      </tar-dropdown-menu>
    } @else {
      <button class="navbar__login" (click)="login()">
        {{ 'Login' | translate }}
      </button>
    }
    <app-logout-dialog #logoutDialog></app-logout-dialog>
  </ul>
</nav>
